<template>
  <div class="animate__animated animate__fadeIn">
    <el-card style="margin:  10px -10px;width: 100%;">

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!--     ================================ 我的任务 ====================================     -->
        <el-tab-pane label="我的任务" name="my-task">
          <my-task :is-ordinary-consumer="true" :for-review="false" :read-only="false"></my-task>
        </el-tab-pane>
        <!--     ================================ 任务管理（包括发布任务） ====================================     -->
        <el-tab-pane v-if="displayForManage" label="任务管理" name="task-manage">
          <my-task :is-ordinary-consumer="false" :operation="taskManageOperation" :for-review="false"
                   :read-only="readOnlyForManage"></my-task>
        </el-tab-pane>

        <!--     ================================ 任务审核 ====================================     -->
        <el-tab-pane v-if="displayForReview" label="任务审核" name="task-review">
          <task-review :is-ordinary-consumer="false" :read-only="readOnlyForReview"></task-review>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>

</template>

<script>
import MyTask from "./MyTask";
import TaskManage from "./TaskManage";
import {mapState} from "vuex";
import {getUrlParam} from "../../../utils/url";
import router from '../../../router/index.js'
import TaskReview from "./TaskReview";

export default {
  name: "Task",
  computed: {
    ...mapState(['userInfo'])
  },
  components: {
    TaskReview,
    MyTask,
    TaskManage,
  },
  data: function () {
    return {
      activeName: 'my-task',
      taskManageOperation: null,
      readOnly: false,
      readOnlyForReview: false,
      readOnlyForManage: false,
      displayForManage: false,
      displayForReview: false,
    }
  },
  created() {
    if (this.isDisplayForManage()) {
      this.taskManageOperation = this.$route.params.operation;
      this.activeName = 'task-manage';
    }
    // 判断是否显示，或者是否只读
    this.displayForManage = this.isDisplayForManage();
    this.displayForReview = this.isDisplayForReview();
    this.readOnlyForManage = this.isReadonlyForManage();
    this.readOnlyForReview = this.isReadonlyForReview();
    // console.log(this.readOnly)
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    isDisplayForManage() {
      return this.userInfo.consumerLevel === '管理员'
        || this.userInfo.consumerLevel === '超级管理员'
        || this.userInfo.consumerLevel === '审核'
        || this.userInfo.consumerLevel === '客服'
        || this.userInfo.consumerLevel === '客服主管'
        || this.userInfo.consumerLevel === '售后';
    },
    isDisplayForReview() {
      return this.userInfo.consumerLevel === '管理员'
        || this.userInfo.consumerLevel === '超级管理员'
        || this.userInfo.consumerLevel === '审核';
    },
    isReadonlyForManage() {
      return this.userInfo.consumerLevel !== '管理员'
        && this.userInfo.consumerLevel !== '超级管理员'
        && this.userInfo.consumerLevel !== '客服'
        && this.userInfo.consumerLevel !== '客服主管'
        && this.userInfo.consumerLevel !== '售后';
    },
    isReadonlyForReview() {
      return this.userInfo.consumerLevel !== '管理员'
        && this.userInfo.consumerLevel !== '超级管理员'
        && this.userInfo.consumerLevel !== '审核';

    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/functions/task/Task.vue